import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

function BarChartStats({ eventSeriesData, submissionsInsideEvent }) {
  console.log("Submissions Inside Event:", submissionsInsideEvent);
  console.log("Event Series Data:", eventSeriesData);

  //Get number of submissions for each week in the month
  const submissionsByWeek = React.useMemo(() => {
    if (!submissionsInsideEvent || !submissionsInsideEvent.length) return [];

    console.log("Went inside the memo");
    const weekCounts = [0, 0, 0, 0];

    const lastWeeksCounts = [0, 0, 0, 0];

    submissionsInsideEvent.forEach((item) => {
      // console.log("Submission:", item.submissions);

      item.submissions.submissions.forEach((submission) => {
        // console.log("Submission:", submission);
        if (submission.submitted_at) {
          const date = new Date(submission.submitted_at);
          //Get this month'submission date
          const month = date.getMonth();
          const year = date.getFullYear();
          const week = Math.floor(date.getDate() / 7); 
          //console.log("Week:", week);

          //Check if the submission is in the current month
          if (
            month === new Date().getMonth() &&
            year === new Date().getFullYear()
          ) {
            // Increment the count for the corresponding week
            weekCounts[week] = (weekCounts[week] || 0) + 1;
          }

            //Check if the submission is in the last month
            if (month === new Date().getMonth() - 1 && year === new Date().getFullYear()
                ) {
                // Increment the count for the corresponding week
                lastWeeksCounts[week] = (lastWeeksCounts[week] || 0) + 1;
                }
        }

        console.log("lastWeeksCounts", lastWeeksCounts);
      });
    });
    return {weekCounts,lastWeeksCounts};
  }, [submissionsInsideEvent]);

  console.log("Submissions by Week:", submissionsByWeek.weekCounts);
  console.log("Submissions by Last Week:", submissionsByWeek.lastWeeksCounts);

  return (
    <div style={{ height: "100%", width: "100%", padding: "10px" }}>
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: ["Week 1", "Week 2", "Week 3", "Week 4"],
            tickLabelStyle: {
              fontSize: 12,
              fontWeight: 500,
            },
          },
        ]}
        yAxis={[
          {
            tickLabelStyle: {
              fontSize: 12,
            },
          },
        ]}
        series={[
          {
            data: submissionsByWeek.weekCounts || [0, 0, 0, 0],
            label: "This month",
           
          },
          {
            data: submissionsByWeek.lastWeeksCounts || [0, 0, 0, 0],
            label: "Last month",
            color: "#fc8403",
          
          },
        ]}
        height={420}
        colors={["#249635"]}
        slotProps={{
          bar: {
            borderRadius: 4,
            paddingRadius: 2,
          },
        }}
        tooltip={{ trigger: "item" }}
        axisHighlight={{ x: "line", y: "none" }}
        barLabel="value"
        sx={{
          ".MuiBarElement-root:hover": {
            filter: "brightness(0.9)",
          },
        }}
      />
    </div>
  );
}

export default BarChartStats;
